/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for any purpose without the express written permission of Honeywell.�*/

import GetTokenValues from "./GetTokenValues";

const getLoggedInUserId = () => {
  const tokenValues = GetTokenValues();
  let accessTokenPayload =
    tokenValues !== undefined
      ? tokenValues.accessTokenPayload
      : {
          sub: "",
          ext: {
            customer: "",
            tenant_id: "",
          },
        };

  const tokenInfo = {
    customer: accessTokenPayload?.ext?.customer ?? "",
    tenant: accessTokenPayload?.ext?.tenant_id ?? "",
    userId: accessTokenPayload?.sub ?? "",
  };
  return tokenInfo.userId;
};
export default getLoggedInUserId;
